import type {AppProfileWithId, ConnectorStruct} from '@cohort/shared/schema/apps/app';
import type {OAuth2AppCredentials, OAuth2Credentials} from '@cohort/shared/schema/apps/oauth';
import {basicOauth2ConnectorSpec} from '@cohort/shared/schema/apps/oauth';

export type InstagramMerchantUserCredentials = OAuth2Credentials & {
  pageAccessToken: string;
  instagramAccountId: string;
};

export type InstagramMerchantConnectorStruct = ConnectorStruct<
  'instagram-merchant',
  OAuth2AppCredentials,
  InstagramMerchantUserCredentials,
  AppProfileWithId,
  null
>;

export const InstagramMerchantConnectorSpec =
  basicOauth2ConnectorSpec<InstagramMerchantConnectorStruct>('instagram-merchant');
